// This file is generated.
export var version = '1.82.0';
//# sourceMappingURL=version.js.map